module.exports = __webpack_public_path__ + "static/media/icofont.529c3ac7.ttf";